<template>
  <div class="container-fluid">
    <loading :active.sync="loading"
             :loader="'dots'"
             :color="'#58f0ac'"
             :width="128"
             :background-color="'#000'"
             :opacity="0.75"
             :can-cancel="false"
             :is-full-page="true"></loading>
    <div class="row justify-content-center" style="margin-top:12vh"  v-on:keyup.13="sendLogin">
      <div class="col-12">
        <h1 style="text-align: center; font-size:60px; margin-bottom:30px">Terra Aqua</h1>
      </div>
      <card class="col-11 col-sm-11 col-md-8 col-lg-6 col-xl-3">
        <h5 slot="header" class="login-title">PRIJAVA</h5>
        <div class="row justify-content-center">
          <div class="col-12  col-sm-12 col-md-9 col-lg-10 col-xl-9 mt-3" style="font-size:25px !important;">
            <base-input label="Email adresa"
                        type="email"
                        v-model="email"
                        placeholder="Unesi email">
            </base-input>
          </div>
          <div class="col-12 col-sm-12 col-md-9 col-lg-10 col-xl-9 mt-3">
            <base-input label="Šifra"
                        type="password"
                        v-model="password"
                        placeholder="Unesi sifru">

            </base-input>
          </div>
          <div class="col-12 col-sm-12 col-md-8  col-lg-10 col-xl-10 mt-3" v-if="wrongLogin">
            <base-alert type="warning">
              <p style="font-size:18px; font-weight: 700; letter-spacing: 0.3px;">Pogrešna email adresa ili šifra!</p>
            </base-alert>
          </div>
          <div class="col-12 col-sm-12 col-md-6  col-lg-5 col-xl-5 mt-3">
            <base-button type="info" block @click="sendLogin" >Uloguj se</base-button>
          </div>
        </div>
      </card>
    </div>
  </div>
</template>
<script>
  import AuthServices  from "@/services/AuthServices"

  export default {
    data() {
      return {
        email: "",
        password: "",
        loading: false,
        wrongLogin: false
      }
    },
    methods: {
      async sendLogin() {
        try {
          if (this.email == "" || this.password == "") return;
          this.wrongLogin = false;
          this.loading = true;
          let response = await AuthServices.loginUser({email: this.email, password: this.password})
          this.loading = false;
          if (response.data && response.data.success) {
            let token = response.data.token
            localStorage.setItem("user_jwt", token)
            this.$router.push("/")
          } else {
            this.wrongLogin = true;
          }
        } catch (err) {
          console.log("Server not responding!")
          this.loading = false;
          this.$notify({verticalAlign: 'bottom', horizontalAlign: 'right',  type: 'warning', message: 'Greška u komunikaciji sa serverom!'});

        }
      }
    }
  }
</script>
<style>
  .control-label {
    font-size: 25px !important;
  }

  .form-control {
    font-size: 20px !important;
    height: 55px !important;
  }

  .login-title {
    font-size: 30px;
    text-align: center;
  }
</style>
